var _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEthereum = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 50,
    viewBox: "0 0 24 24",
    width: 50,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2.5 2.5h19v19h-19z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 2.5-.13.43v12.57l.13.12 5.83-3.44z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 2.5-5.83 9.68 5.83 3.44z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 16.73-.07.08v4.48l.07.21 5.83-8.22z",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 21.5v-4.77l-5.83-3.45z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 15.63 5.83-3.45-5.83-2.65z",
    fill: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.17 12.18 5.83 3.45v-6.1z",
    fill: "#eee"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEthereum);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ethereum.de505b1cb1b785aeb55fc7197d1ee914.svg";